import { Component, OnInit, Input } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FactorStrategy } from 'src/app/models/factor-strategy.model';

@Component({
  selector: 'app-portfolio-models-performance',
  templateUrl: './portfolio-models-performance.component.html',
  styleUrls: ['./portfolio-models-performance.component.scss']
})
export class PortfolioModelsPerformanceComponent implements OnInit {

  @Input() strategy1: FactorStrategy;
  @Input() strategy2: FactorStrategy;
  @Input() strategy3: FactorStrategy;

  @Input() inceptionDate: Date;
  @Input() lastDate: Date;

  selectedAllTab: string = 'overview';
  selectedOverviewTab: string = 'all';
  selectedAbsoluteTab: string = 'Returns';
  selectedRelativeTab: string = 'Excess Returns';

  lastYears: number[] = [2015,2016,2017,2018,2019];

  constructor() { }

  ngOnInit(): void {
  }

  onOverviewTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'All since inception': this.selectedOverviewTab='all'; break;
      case this.strategy1.name:   this.selectedOverviewTab='default1'; break;
      case this.strategy2.name:   this.selectedOverviewTab='default2'; break;
      case this.strategy3.name:   this.selectedOverviewTab='default3'; break;
    }
  }

  onAbsoluteTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Returns':               this.selectedAbsoluteTab='Returns'; break;
      case 'Volatility':            this.selectedAbsoluteTab='Volatility'; break;
      case 'Sharpe ratio':          this.selectedAbsoluteTab='Sharpe ratio'; break;
      case 'Max Drawdown':          this.selectedAbsoluteTab='Max Drawdown'; break;
      case 'Value at Risk':         this.selectedAbsoluteTab='Value at Risk'; break;
      case 'Calmar ratio':          this.selectedAbsoluteTab='Calmar ratio'; break;
      case 'Yearly Returns':        this.selectedAbsoluteTab='Yearly Returns'; break;
    }
  }

  onRelativeTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Excess Returns':         this.selectedRelativeTab='Excess Returns'; break;
      case 'Tracking Error':         this.selectedRelativeTab='Tracking Error'; break;
      case 'Information ratio':      this.selectedRelativeTab='Information ratio'; break;
      case 'Max Relative Drawdown':  this.selectedRelativeTab='Max Relative Drawdown'; break;
      case 'Market Exposure':        this.selectedRelativeTab='Market Exposure'; break;
    }
  }

}
